// Maps a period's start date to the calendar quarter the VAT & PE tab reports on,
// so the dashboard snapshot and the VAT & PE tab always agree for the same period.
export function dateToQuarter(dateFrom: string): string {
  const [yearStr, monthStr] = dateFrom.split('-');
  const q = Math.ceil(parseInt(monthStr, 10) / 3);
  return `Q${q}_${yearStr}`;
}

/**
 * The first and last calendar day of a "Q1_2026" quarter, as YYYY-MM-DD.
 * Mirrors the backend's quarter boundaries, built from strings so no timezone
 * can shift a bound onto the neighbouring day. Null for a malformed value.
 */
export function quarterToDateRange(
  quarter: string,
): { dateFrom: string; dateTo: string } | null {
  const match = /^Q([1-4])_(\d{4})$/.exec(quarter);
  if (!match) return null;
  const q = Number(match[1]);
  const year = Number(match[2]);
  const startMonth = (q - 1) * 3 + 1;
  const endMonth = startMonth + 2;
  // Day 0 of the following month is the last day of endMonth.
  const lastDay = new Date(year, endMonth, 0).getDate();
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    dateFrom: `${year}-${pad(startMonth)}-01`,
    dateTo: `${year}-${pad(endMonth)}-${pad(lastDay)}`,
  };
}
